import Vue from 'vue'

import Auth from '@/services/auth'
Vue.directive('check-auth', function (el, binding) {
  let auth = binding.value
  auth = '/admin/v1' + auth
  if (!Auth.checkAuth(auth)) {
    el.classList.add('hide')
    if (el && el.parentNode) el.parentNode.removeChild(el)
  }
})
